/**
 * Cooler Data Adapter
 *
 * Loads Cooler detail data and merges with pricing data from separate files.
 * Uses the generic adapter pattern for consistency.
 */

import type { CoolerModel } from '../../models/cooler/cpu-cooler-model'
import { createSingletonAdapter, type GenericDataAdapter } from '../common/GenericDataAdapter'

// Create singleton instance using generic adapter
const { getAdapter, resetAdapter } = createSingletonAdapter<CoolerModel>({
  basePath: '/data/cooler',
  componentName: 'cooler'
})

/**
 * Get the singleton instance of CoolerDataAdapter
 */
export function getCoolerDataAdapter(): GenericDataAdapter<CoolerModel> {
  return getAdapter()
}

/**
 * Reset the singleton instance (useful for testing)
 */
export function resetCoolerDataAdapter(): void {
  resetAdapter()
}

// Re-export for backward compatibility
export type CoolerDataAdapter = GenericDataAdapter<CoolerModel>
